import { axiosService } from '../.';

export default class UpdateOrganizationBusinessOtherLinks {
    public async execute(input: UpdateOrganizationBusinessOtherLinksDto): Promise<void> {
        await axiosService.instance.post(`businesses/organization/update-external-links-other-type`, input);
    }
}

export class UpdateOrganizationBusinessOtherLinksDto {
    private businessId: number;
    private links: UpdateOrganizationBusinessOtherLinksLinkDto[];

    constructor(businessId: number, links: UpdateOrganizationBusinessOtherLinksLinkDto[]) {
        this.businessId = businessId;
        this.links = links;
    }
}

export class UpdateOrganizationBusinessOtherLinksLinkDto {
    private title: string;
    private url: string;
    private type: number;

    constructor(title: string, url: string, type: number) {
        this.title = title;
        this.url = url;
        this.type = type;
    }
}

export const updateOrganizationBusinessOtherLinks = new UpdateOrganizationBusinessOtherLinks();
